@use '../../styling/typography.scss' as *;
@use '../../styling/colors.scss' as *;

.RemovableItem {
  border: 1px solid $theme-color-table-border;
  padding: 0px 6px;
  border-radius: 6px; // ETD-539
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 80px;
  height: 26px;

  button {
    margin-left: 0.25em;
  }

  &.RemovableItemDisabled {
    background: $theme-color-table-header-footer;
    color: $theme-color-text;
    border: 1px solid $color-grey-A;
  }
}